import { ArrowUpRight, Award, Megaphone, Rocket, Target, Trophy } from "lucide-react";
import { Link } from "react-router-dom";
import { services } from "@/data/siteContent";
import { Reveal } from "@/components/common/Reveal";

const serviceIcons = [Trophy, Target, Award, Megaphone, Rocket];

export default function ServicesPage() {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-10 pb-16 sm:space-y-14" data-testid="services-page">
      <Reveal>
        <section className="space-y-5" data-testid="services-hero-section">
          <p className="font-oswald text-xs uppercase tracking-[0.24em] text-accent" data-testid="services-kicker">
            Services
          </p>
          <h1 className="font-oswald text-4xl uppercase leading-tight text-white sm:text-5xl" data-testid="services-main-heading">
            End-To-End Services Across Talent, IP, And Brand Strategy
          </h1>
          <p className="max-w-3xl text-sm text-blue-100/95 sm:text-base" data-testid="services-intro-text">
            From athlete partnerships to sports IP activations, Purnam executes campaigns that connect culture with
            measurable brand outcomes.
          </p>
        </section>
      </Reveal>

      <section className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
        {services.map((service, index) => {
          const Icon = serviceIcons[index];
          return (
            <Reveal key={service.title} delay={index * 0.06}>
              <Link
                to={`/services/case-study/${service.slug}`}
                className="group block h-full rounded-2xl border border-blue-100/20 bg-card/65 p-6 transition-all duration-300 hover:border-accent/70 hover:bg-card"
                data-testid={`service-card-link-${index + 1}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <Icon size={20} className="text-accent" />
                  <ArrowUpRight size={16} className="text-blue-100/75 transition-colors duration-300 group-hover:text-accent" />
                </div>
                <h2 className="mt-4 font-oswald text-xl uppercase text-white" data-testid={`service-title-${index + 1}`}>
                  {service.title}
                </h2>
                <p className="mt-3 text-sm text-blue-100/90" data-testid={`service-description-${index + 1}`}>
                  {service.description}
                </p>
                <ul className="mt-4 space-y-2" data-testid={`service-deliverables-${index + 1}`}>
                  {service.deliverables.map((point) => (
                    <li
                      key={point}
                      className="text-xs uppercase tracking-[0.14em] text-blue-100/80"
                      data-testid={`service-deliverable-item-${index + 1}-${point.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    >
                      {point}
                    </li>
                  ))}
                </ul>
                <p className="mt-5 font-oswald text-xs uppercase tracking-[0.16em] text-accent" data-testid={`service-case-study-hint-${index + 1}`}>
                  View Case Study
                </p>
              </Link>
            </Reveal>
          );
        })}
      </section>
    </div>
  );
}